import { useState, useCallback, useEffect, useRef } from 'react';
import { Header, Chat } from './components';
import './App.css';

function App() {
  const [chatKey, setChatKey] = useState(0);
  const healthCheckExecuted = useRef(false);

  // Проверяем здоровье API при загрузке приложения (только один раз)
  useEffect(() => {
    if (healthCheckExecuted.current) return;
    
    const checkApiHealth = async () => {
      try {
        healthCheckExecuted.current = true;
      } catch (error) {
        console.error('API Health Check Failed:', error);
      }
    };

    checkApiHealth();
  }, []);

  const handleNewChat = useCallback(() => {
    // Очищаем localStorage и пересоздаем чат
    localStorage.removeItem('chat_thread_id');
    setChatKey(prev => prev + 1);
  }, []);

  return (
    <div className="app">
      <Header onNewChat={handleNewChat} />
      <Chat key={chatKey} />
    </div>
  );
}

export default App;